window.tania = {
  isMobile: $(window).width() < 1024,
  isDesktop: $(window).width() > 1024,
  methods: {
    handleMenuImageHover: function() {
      try {
        // Verifica se o recurso de imagem está habilitado
        const enableCollectionImage = document.querySelector('.custom-collection-image__wrapper');
        if (!enableCollectionImage) {
          console.warn('Contêiner de imagem de coleção não encontrado');
          return;
        }

        const menuLinks = document.querySelectorAll('.header-full-menu__menu-columns-link[data-image]');
        if (!menuLinks.length) {
          console.warn('Nenhum link de menu com atributo data-image encontrado');
          return;
        }

        // Itera sobre cada link do menu
        menuLinks.forEach((link) => {
          const imageUrl = link.getAttribute('data-image');
          
          link.addEventListener('mouseenter', () => {
            const container = link.closest('.header-full-menu__menu--has-megamenu');
            if (!container) {
              console.error('Container do menu não encontrado');
              return;
            }
            
            const secondImageContainer = container.querySelector('.custom-collection__second-image');
            if (!secondImageContainer) {
              console.error('Elemento .custom-collection__second-image não encontrado');
              return;
            }
        
            // Esconde a imagem atual
            secondImageContainer.classList.add('custom-collection__image--hidden');
            secondImageContainer.classList.remove('custom-collection__image--visible');
            
            // Pequeno atraso para garantir que a classe de esconder seja aplicada
              try {
                secondImageContainer.removeAttribute('srcset');
                secondImageContainer.removeAttribute('src');
                // Primeiro define o src
                secondImageContainer.src = imageUrl;
                
                // Quando a nova imagem carregar
                secondImageContainer.onload = function() {
                  // Pequeno atraso para garantir que a imagem foi carregada
                  setTimeout(() => {
                    secondImageContainer.classList.remove('custom-collection__image--hidden');
                    secondImageContainer.classList.add('custom-collection__image--visible');
                  }, 100); // Reduzido para 30ms para uma transição mais rápida
                };
                
                // Tratamento de erro no carregamento da imagem
                secondImageContainer.onerror = function() {
                  console.error('Erro ao carregar a imagem:', imageUrl);
                };
              } catch (error) {
                console.error('Erro ao atualizar a imagem:', error);
              }
          });
        });
      } catch (error) {
        console.error('Erro no handleMenuImageHover:', error);
      }
    },
    getCloseIcon() {
      return `<svg data-action="remove-product-added-modal" xmlns="http://www.w3.org/2000/svg" width="12.707" height="12.707" viewBox="0 0 12.707 12.707">
                  <g id="Componente_13_7" data-name="Componente 13 – 7" transform="translate(0.354 0.354)">
                    <line id="Linha_19" data-name="Linha 19" x2="12" y2="12" fill="none" stroke="#989289" stroke-width="1"/>
                    <line id="Linha_20" data-name="Linha 20" x1="12" y2="12" fill="none" stroke="#989289" stroke-width="1"/>
                  </g>
                </svg>`
    },
    categorySelectorTab() {
      const tab = $(".e-category__tabs>.tab");
      const content = $(".e-category__content__wrapper");
      const descriptionContent = $(".e-category__description");

      tab.on("click", function () {
        const btn = $(this);
        if (btn.hasClass("is-active")) return;

        tab.removeClass("is-active");
        btn.addClass("is-active");

        const id = btn.attr("data-id");
        content.removeClass("is-active");
        descriptionContent.removeClass("is-active");
        $(`[id="${id}"]`).addClass("is-active");
        $(`[data-description-id="${id}"]`).addClass("is-active");
      });
    },
    initTabsSlider: function () {
      const options = {
        type: "slide",
        flickPower: 500,
        drag: "free",
        perPage: 4,
        perMove: 1,
        gap: 40,
        pagination: false,
        arrows: true,
        rewind: false,
        lazyLoad: "nearby",
        breakpoints: {
          1600: {
            perPage: 3,
            gap: 30,
          },
          1140: {
            perPage: 2,
            perMove: 1,
            gap: 30,
          },
          600: {
            gap: 20,
          },
        },
      };

      if ($(".splide--1").length) {
        new Splide(".splide--1", options).mount();
      }
      if ($(".splide--2").length) {
        new Splide(".splide--2", options).mount();
      }
      if ($(".splide--3").length) {
        new Splide(".splide--3", options).mount();
      }
      if ($(".splide--4").length) {
        new Splide(".splide--4", options).mount();
      }
      if ($(".splide--5").length) {
        new Splide(".splide--5", options).mount();
      }
      if ($(".splide--6").length) {
        new Splide(".splide--6", options).mount();
      }
    },
    initMobileProductSlider: function () {
      if (tania.isDesktop) return;

      const options = {
        type: "loop",
        perPage: 1.5,
        perMove: 1,
        drag: "free",
        gap: 10,
        pagination: false,
        arrows: false,
        rewind: true,
        lazyLoad: "nearby",
        breakpoints: {
          1140: {
            gap: 20,
          },
          640: {
            gap: 10,
          },
        },
      };

      if ($(".splide-product-mobile").length) {
        new Splide(".splide-product-mobile", options).mount();
      }
    },
    initDesktopShelfProductSlider: function () {
      const options = {
        type: "slide",
        flickPower: 500,
        drag: "free",
        perPage: 4,
        perMove: 1,
        gap: 60,
        pagination: false,
        arrows: true,
        rewind: false,
        lazyLoad: "nearby",
        breakpoints: {
          1600: {
            perPage: 3,
            gap: 30,
          },
          1140: {
            perPage: 2,
            perMove: 1,
            gap: 30,
          },
        },
      };

      if ($(".splide-collection-products").length) {
        new Splide(".splide-collection-products", options).mount();
      }
      if ($(".splide-recommended-products").length) {
        new Splide(".splide-recommended-products", options).mount();
      }
    },
    initMobileShelfProductSlider: function () {
      if (tania.isDesktop) return;

      const options = {
        type: "slide",
        flickPower: 500,
        drag: "free",
        perPage: 2,
        perMove: 1,
        gap: 20,
        pagination: false,
        arrows: true,
        rewind: false,
        lazyLoad: "nearby",
      };

      if ($(".splide-collection-products-mobile").length) {
        new Splide(".splide-collection-products-mobile", options).mount();
      }

      if ($(".splide-recommended-products-mobile").length) {
        new Splide(".splide-recommended-products-mobile", options).mount();
      }
    },
    initPhotoSlider: function () {
      if (tania.isDesktop) return;

      const options = {
        type: "loop",
        perPage: 1.5,
        drag: "free",
        perMove: 1.5,
        pagination: false,
        arrows: true,
        rewind: true,
        breakpoints: {
          1024: {
            gap: 20,
          },
          640: {
            gap: 10,
          },
        },
      };

      if ($(".splide-carrossel-horizontal").length) {
        new Splide(".splide-carrossel-horizontal", options).mount();
      }
    },
    insertAnimationinText: function () {
      const stripText = document.querySelector(".section-highlighted-strip");
      const aboutImageWrapper = document.querySelector(".e-about__images");

      const callbackFunction = (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      };

      const options = {
        root: null,
        rootMargin: "0px",
        threshold: 0.5,
      };

      const textObserver = new IntersectionObserver(callbackFunction, options);

      if (aboutImageWrapper instanceof Element) {
        textObserver.observe(aboutImageWrapper);
      }

      if (stripText instanceof Element) {
        textObserver.observe(stripText);
      }
    },

    setHeaderImagesWidth: function () {
      const menuItems = $(".menu-link");

      menuItems.each((_index, item) => {
        const submenuContainer = $(item).find("ul");
        const submenuItems = $(submenuContainer).children("li");
        const numberOfsubItems = submenuItems.length;
        const maxItemsForOneColumn = 7;

        const collectionImages = $(item).find(
          ".e-menu__dropdown--child--image, .menu-link__child--image"
        );

        if (numberOfsubItems > maxItemsForOneColumn) {
          collectionImages.addClass("is-small");
        } else {
          collectionImages.addClass("is-large");
        }
      });
    },
    handleShelfDisplay() {
      const tab = $(".e-product__shelf--tabs > [data-action]");
      const collectionShelf = $(".product-collection");
      const recommendationShelf = $(".product-recommendations");

      tab.on("click", function () {
        const btn = $(this);
        if (btn.data("action") === "show-product-collection") {
          collectionShelf.fadeIn();
          recommendationShelf.hide();
        }
        if (btn.data("action") === "show-product-recommendations") {
          collectionShelf.hide();
          recommendationShelf.fadeIn();
        }
      });
    },
    handleIsLoadingSidebar: function () {
      const sidebar = $(".e-menu-mobile");

      sidebar.removeClass("is-loading");
    },
    handleMobileProductRedirect: function () {
      if (tania.isDesktop) return;

      const product = $("[data-href]");
      const producUrl = product.data("href");

      product.attr("href", producUrl);
    },
    removeQuickview: function () {
      const modal = $(".Product__Modal");
      const overlay = $(".modal__overlay");
      const body = $("body");

      modal.remove();
      overlay.remove();
      body.removeClass("overflow-hidden");
    },
    toggleLoading: function (_time) {
      $("body").append('<div class="e-loading-more"></div>');

      setTimeout(function () {
        $(".e-loading-more").remove();
      }, _time);
    },
    handleInputQuantityModal: function () {
      const plusBtn = $('[data-action="changeQuantity-add"]');
      const minusBtn = $('[data-action="changeQuantity-minus"]');

      plusBtn.on("click", function () {
        const quantity = $(this).closest("form").find('input[type="number"]');
        const quantityValue = Number(quantity.val());

        const maxQuantity = quantity.attr("max");

        if (quantityValue >= maxQuantity) {
          const product_notification = `
          <div class="e-product-notification">
            <div class="e-product-notification__info">
              <p class="e-product-notification__message">
                <strong>
                Only ${maxQuantity} item(s) available.
                </strong>
                ${this.getCloseIcon()}
              </p>
            </div>
          </div>
          `;

          $("body").append(product_notification);

          quantity.val(maxQuantity);

          setTimeout(() => {
            $("body").find(".e-product-notification").remove();
          }, 3000);
        } else {
          quantity.val(quantityValue + 1);
        }
      });

      minusBtn.on("click", function () {
        const quantity = $(this).closest("form").find('input[type="number"]');
        const quantityValue = Number(quantity.val());
        if (quantityValue === 1) return;

        quantity.val(quantityValue - 1);
      });
    },

    removeProductModal: function () {
      const product_notification = $(".e-product-notification");
      product_notification.fadeOut(500);
      product_notification.remove();
    },
    createAddedProductModal: function ({ quantity, handle }) {
      const hasAlreadyANotification = $(".e-product-notification");

      if (hasAlreadyANotification.length > 0) return;

      $.ajax({
        type: "GET",
        url: `/products/${handle}?view=complete.json`,
        success: function (response) {
          const data = JSON.parse(response);
          const { product } = data;

          const product_notification = `
          <div class="e-product-notification">
            <img class="lazyload" data-src="${
              product.featured_image
            }" width="120">
            <div class="e-product-notification__info">
              <p class="e-product-notification__message">
                <strong>
                  Added to cart
                </strong>
                ${this.getCloseIcon()}
              </p>
              <p class="e-product-notification__product-info">
                <span>${quantity}x
                  <span class="e-product-notification__info__product-name">${
                    product.type
                  }</span>
                </span>
                <span>
                <span class="e-product-notification__info__product-price">${(
                  product.line_price_without_zeros
                ).toLocaleString("en-US", {
                  style: "currency",
                  currency: "USD",
                })} </span>
                • ${product.collection.join("")}
                </span>
              </p>
            </div>
          </div>
          `;

          $("body").append(product_notification);
        },
      });
    },
    textMainBannerAnimate: function () {
      const textMainBanner = $(".e-image-hero__content--texts");

      textMainBanner.animate(
        {
          opacity: 1,

          top: "50%",

          transform: "translateY(-50%)",

          transition: "all 1s ease-in-out",
        },
        3000
      );
    },
    init: function () {
      this.categorySelectorTab();
      this.setHeaderImagesWidth();
      this.textMainBannerAnimate();
      this.handleMenuImageHover();
    },

    init_ajax: function () {},
  },
  cartMethods: {
    handleCartDot: function () {
      const cartDot = $(".e-header__links--cart-dot");
      const hasActiveClass = cartDot.hasClass(
        "e-header__links--cart-dot--is-active"
      );

      if (!hasActiveClass) {
        cartDot.addClass("e-header__links--cart-dot--is-active");
      }
    },
    addProductToCart: function ({ formData, handle, isQuickViewButton }) {
      const { quantity } = formData.items[0];

      $.ajax({
        url: window.Shopify.routes.root + "cart/add.js",
        type: "POST",
        data: formData,
        success: function (data, status) {
          tania.cartMethods.handleCartDot();

          setTimeout(() => {
            const minicart = $("[data-drawer-target]");
            window.populateMinicart();
            minicart.addClass("is-active");
            $("body").addClass("overflow-hidden");

            setTimeout(function () {
              minicart.addClass("is-visible");
            }, 50);
          }, 50);

          tania.methods.removeQuickview();
        },
        error: function (data) {
          const product_notification = `
          <div class="e-product-notification ${
            isQuickViewButton && "e-minicart-notification"
          }">
            <div class="e-product-notification__info">
              <p class="e-product-notification__message">
                <strong>
                  ${JSON.parse(data.responseText).description}
                </strong>
                ${this.getCloseIcon()}
              </p>
            </div>
          </div>
          `;

          $("body").append(product_notification);

          quantity.val(maxQuantity);

          setTimeout(() => {
            $(".e-product-notification.e-minicart-notification").remove();
          }, 3000);
        },
      });
    },
    emptyCart: function () {},
    removeProductFromCart: function (variantId) {
      // Verificar se a página está completamente carregada antes de fazer a chamada
      if (document.readyState !== 'complete') {
        // Se não estiver, adiar a execução para quando estiver completamente carregada
        window.addEventListener('load', () => this.removeProductFromCart(variantId));
        return;
      }
      
      // Garantir que o variantId seja válido antes de enviar
      if (!variantId) {
        console.warn("Tentativa de remover produto sem variant ID válido");
        return;
      }
      
      $.ajax({
        type: "POST",
        url: "/cart/update.js",
        data: `updates[${variantId}]=0`,
        dataType: 'json',
        success: function (response) {
          if (typeof window.populateMinicart === 'function') {
            window.populateMinicart();
          }
        },
        error: function (status) {
          console.warn("Erro ao remover produto do carrinho:", status);
        },
      });
    },
  },
  events: {
    onAddToCart: function () {
      const addButton = '[data-action="add-to-cart"]';
      const quickViewModalOverlay = document.querySelector('[data-product-modal-overlay]')

      $(document).on("click", addButton, function (e) {
        e.preventDefault();

        const isQuickViewButton =
          $(this).closest("[data-product-modal][data-open=true]").length || false;
        const form = $(this).closest("form");
        const id = $(form).find('input[type="hidden"]').val();
        const quantity = $(form).find('input[type="number"]').val();
        const complementProductVariantId = $(form).find('input[name="complement-product"]').val() || null;
        const complementProductName = $(form).find('input[name="complement-product-name"]').val() || null;
        const handle = $(form).data("product-handle");
        const propertiesKey = id + "-" + complementProductVariantId;

        const formData = {
          items: [
            {
              id,
              quantity,
              properties:
                complementProductVariantId ?
                  { complementProduct:
                      { variantId: complementProductVariantId,
                        key: propertiesKey,
                        name: complementProductName
                      }
                  } : {}
            },
          ],
        };
        
        if(complementProductVariantId) {
          formData.items.push({
            id: complementProductVariantId,
            quantity,
            properties: { complementProduct: { key: propertiesKey }}
          })
        }

        if(isQuickViewButton) {
          quickViewModalOverlay.click();
        }
        
        tania.cartMethods.addProductToCart({
          formData,
          handle,
          isQuickViewButton
        });
      });
    },
    onRemoveFromCart: function () {
      const removeButton = '[data-action="remove-cart-product"]';

      $(document).on("click", removeButton, function () {
        const variantId = Number($(this).data("variant-id"));
        tania.cartMethods.removeProductFromCart(variantId);
      });
    },
    onRemoveAddedNotification() {
      $(document).on(
        "click",
        '[data-action="remove-product-added-modal"]',
        function () {
          tania.methods.removeProductModal();
        }
      );
    },
    goToTop: function () {
      const button = $('[data-action="go-to-top"]');

      $(window).scroll(function () {
        if ($(this).scrollTop() > 1000) {
          button.fadeIn();
        } else {
          button.fadeOut();
        }
      });

      button.on("click", function () {
        $("html, body").animate(
          {
            scrollTop: 0,
          },
          "slow"
        );
      });
    },
    animateMainText: function () {
      const mainText = $(".e-image-hero__content--texts");

      mainText.animate({
        opacity: 1,
      });
    },
    openAccessibilityApp: function () {
      const button = $("#accessibilityWidget");

      button.on("click", function () {
        const accessibilityMenu = $('[aria-label="Accessibility Menu"]');
        accessibilityMenu.click();
      });
    },
    showProductVariants: function () {
      $(document).on(
        "click",
        '[data-action="show-product-variants"]',
        function () {
          const productVariants = $(".e-product__right__variants--options");
          productVariants.slideToggle();
          $(".Product__Modal--wrapper").animate(
            { scrollTop: $(".Product__Modal--wrapper")[0].scrollHeight },
            "slow"
          );
        }
      );

      $(document).on("click", function (event) {
        if (
          !$(event.target).closest('[data-action="show-product-variants"]')
            .length
        ) {
          const productVariants = $(".e-product__right__variants--options");
          productVariants.removeClass("is-active");
        }
      });
    },
    showProductItems: function () {
      $(document).on(
        "click",
        '[data-action="show-product-items"]',
        function () {
          const productItems = $(".e-product__right__items--options");
          const productModalItems = $(
            ".e-product__right__details--item--option"
          );
          productModalItems.toggleClass("is-active");
          productItems.toggleClass("is-active");
        }
      );

      $(document).on("click", ".js--close-itens", function (event) {
        const productVariants = $(".e-product__right__items--options");
        const productModalItems = $(".e-product__right__details--item--option");
        productModalItems.removeClass("is-active");
        productVariants.removeClass("is-active");
      });
    },
  },
  ajax: function () {
    return this.methods.init_ajax();
  },

  mounted: function () {
    return this.methods.init();
  },
};

// Init Functions
$(() => {
  tania.mounted();
});

function menuMethods() {
  $(".e-menu__dropdown__content .menu-link:not(.is-open)").mousemove(function (
    e
  ) {
    const el = $(this);

    const hasOpened = $(".e-menu__dropdown__content .menu-link.is-open").length;

    if (hasOpened) return;

    el.addClass("is-open");
  });

  $(document).on(
    "mouseleave",
    ".e-menu__dropdown__content .menu-link.is-open",
    function (e) {
      const el = $(this);

      const interval = setInterval(() => {
        const onItemOpened =
          $(atual.srcElement).closest(".menu-link.is-open").length > 0 ||
          $(atual.srcElement).hasClass("is-open");

        if (onItemOpened) return;

        el.removeClass("is-open");

        return clearInterval(interval);
      }, 300);
    }
  );

  $(document).on("mouseleave", ".e-header__item .e-menu__item", function (e) {
    $(".e-menu__dropdown__content--links .menu-link").removeClass("is-open");
  });

  $(document).on("mouseenter", ".e-header__item .e-menu__item", function (e) {
    $(".e-menu__dropdown__content--links .menu-link").removeClass("is-open");
  });

  $(".e-header").hover(
    function (e) {
      $(this).addClass("floatHeader");
      $("body").addClass("has-header-floatHeader");
      $("search-input").addClass("white-color");
      $('#icon-search-mobile').css('fill', '#fff');
    },
    function (e) {
      $(this).removeClass("floatHeader");
      $("body").removeClass("has-header-floatHeader");
      $("search-input").removeClass("white-color");
      $('#icon-search-mobile').css('fill', '#796e65');
    }
  );
}

var atual = null;

function mouseEventHandler(mEvent) {
  return (atual = mEvent);
}

document.body.onmousemove = mouseEventHandler;

$(document).ready(function () {
  menuMethods();
  tania.methods.handleInputQuantityModal();
  // tania.methods.handleCreateQuickview();
  tania.events.goToTop();
  tania.events.animateMainText();
  tania.events.showProductVariants();
  tania.events.openAccessibilityApp();
  tania.events.showProductItems();
  tania.events.onAddToCart();
  tania.events.onRemoveFromCart();
  tania.events.onRemoveAddedNotification();
  tania.methods.handleIsLoadingSidebar();
  tania.cartMethods.removeProductFromCart();
  tania.cartMethods.emptyCart();
  tania.methods.handleMenuImageHover();
  // tania.methods.handleMobileProductRedirect();
  // tania.cartMethods.addToCart();
  
  // Controle do header ativo no hover
  const header = document.querySelector('#header');
  if (header) {
    header.addEventListener('mouseenter', () => {
      if (!header.classList.contains('active')) {
        header.classList.add('active');
      }
    });

    header.addEventListener('mouseleave', () => {
      if (header.classList.contains('active')) {
        header.classList.remove('active');
      }
    });

    document.addEventListener(
      'wheel',
      (event) => {
        if(header.classList.contains('active')) {
          event.preventDefault();
        }
      },
      { passive: false }
    );
  }

  if ($("body").hasClass("template-product")) {
    tania.methods.handleShelfDisplay();
    tania.methods.initMobileProductSlider();
    tania.methods.initDesktopShelfProductSlider();
    tania.methods.initMobileShelfProductSlider();
  }

  // Funções para a HomePage
  if (!$("body").hasClass("template-index")) return;

  tania.methods.initTabsSlider();
  tania.methods.initPhotoSlider();
  tania.methods.insertAnimationinText();
});

$(window).on("load", function () {
  tania.methods.insertAnimationinText();
  tania.methods.initPhotoSlider();
});
